import {
  sharedBillingWorkspaceDe,
  sharedBillingWorkspaceEn,
  sharedBillingWorkspaceIt,
  sharedBillingWorkspaceRu,
  sharedBillingWorkspaceUk,
} from "./sharedBillingWorkspaceTranslations";
import { sharedBillingPageDe, sharedBillingPageEn, sharedBillingPageIt, sharedBillingPageRu, sharedBillingPageUk } from "./sharedBillingPageTranslations";
import { sharedInvoiceDesignDe, sharedInvoiceDesignEn, sharedInvoiceDesignIt, sharedInvoiceDesignRu, sharedInvoiceDesignUk } from "./invoiceDesignTranslations";

export const sharedBillingDe = {
  "All payment methods": "Alle",
  "Selected payment methods": "Ausgewählte Zahlungsarten",
  "All future payment methods": "Auch künftig beim Anbieter verfügbare Zahlungsarten sind freigegeben.",
  "Payment provider verification pending": "Die Zahlungsarten werden im Hintergrund geprüft.",
  "Payment method unavailable at provider": "Beim Anbieter nicht verfügbar. Die gespeicherte Auswahl bleibt erhalten.",
  "Failed to load payment providers": "Die Zahlungsanbieter konnten nicht geladen werden. Bitte erneut laden.",
  "PaymentProviderSettingsInvalid": "Die Zahlungseinstellungen sind ungültig. Bitte die Eingaben prüfen.",
  "PaymentProviderCredentialsRequired": "Für die Aktivierung fehlen Zugangsdaten oder Webhook-Angaben.",
  "PaymentProviderMethodsUnavailable": "Mindestens eine Zahlungsart ist beim Anbieter nicht verfügbar. Bitte erneut laden.",
  "PaymentProviderAccessDenied": "Für diese Einstellungen fehlt die Berechtigung.",
  "PaymentProviderConflict": "Die Einstellungen wurden zwischenzeitlich geändert. Bitte erneut laden.",
  "Failed to save payment integration": "Die Zahlungsintegration konnte nicht gespeichert werden. Bitte erneut versuchen.",
  "Reload payment providers": "erneut laden",
  "Payment provider save mismatch": "Die Änderung wurde nicht vollständig gespeichert. Bitte erneut speichern.",
  "Show payment credential": "Zugangsdaten anzeigen",
  "Hide payment credential": "Zugangsdaten verbergen",
  "Payment provider webhook rejected": "Der Webhook konnte nicht bestätigt werden. Bitte die Webhook-ID und die zugehörige PayPal-App prüfen.",
  "Failed to start checkout": "Die Zahlung konnte nicht gestartet werden.",
  "BillingPaymentProviderNotConfigured": "Für diese Zahlung ist kein Zahlungsanbieter eingerichtet.",
  "Pay with PayPal": "Mit PayPal bezahlen",
  "Pay with Stripe": "Mit Stripe bezahlen",
  "Payment provider credentials rejected": "Der Zahlungsanbieter hat die Zugangsdaten abgelehnt. Bitte prüfen.",
  "Payment provider verification failed": "Der Zahlungsanbieter konnte nicht geprüft werden. Bitte erneut versuchen.",
  "Payment provider technical failure": "Die Prüfung wurde wegen einer technischen Störung angehalten. Der Betreiber muss die Ursache beheben.",
  "Webhook endpoint unavailable": "Für diesen Anbieter ist kein Webhook-Endpunkt verfügbar.",
  "Copy webhook address": "Webhook-Adresse kopieren",
  "Webhook address copied": "Webhook-Adresse kopiert",
  ...sharedBillingWorkspaceDe,
  ...sharedBillingPageDe,
  ...sharedInvoiceDesignDe,
  "Stripe integration": "Stripe-Integration",
  "StripeAdminDescription": "Globale Stripe-Konfiguration für Zahlungen. Secret Keys werden nicht im Klartext in der Oberfläche verwaltet.",
  "Inactive": "inaktiv",
  "Secret status": "Secret-Status",
  "configured": "konfiguriert",
  "missing": "fehlt",
  "webhook configured": "Webhook konfiguriert",
  "webhook missing": "Webhook fehlt",
  "Stripe publishable key": "Stripe Publishable Key",
  "Stripe webhook endpoint": "Stripe-Webhook-Endpunkt",
  "Billing plans": "Tarife",
  "Billing promotions": "Aktionen",
  "Add billing plan": "Tarif hinzufügen",
  "Add billing plan version": "Preisvariante hinzufügen",
  "Add billing promotion": "Aktion hinzufügen",
  "Archive plan": "Tarif archivieren",
  "Plan ID": "Tarif-ID",
  "Plan name": "Tarifname",
  "Public plan": "öffentlicher Tarif",
  "Active version": "aktive Variante",
  "Version ID": "Varianten-ID",
  "Version name": "Variantenname",
  "Monthly fee": "monatlicher Nettopreis",
  "Yearly fee": "jährlicher Nettopreis",
  "Annual payment discount": "Rabatt bei jährlicher Zahlung",
  "Currency": "Währung",
  "Published": "veröffentlicht",
  "Trial enabled": "Testzeitraum aktiv",
  "Trial days": "Testtage",
  "Plan limits": "Tariflimits",
  "Set all limits to unlimited": "alle Limits auf unlimitiert setzen",
  "Promotion name": "Aktionsname",
  "Public promotion": "öffentliche Aktion",
  "New customers only": "nur für Neukunden",
  "Assigned plans": "zugeordnete Tarife",
  "Monthly fee override": "abweichender monatlicher Nettopreis",
  "Yearly fee override": "abweichender jährlicher Nettopreis",
  "Starts at": "Startzeit",
  "Ends at": "Endzeit",
  "No billing plans configured": "Keine Tarife konfiguriert",
  "No billing promotions configured": "Keine Aktionen konfiguriert",
  "BillingPriceChangeNotice": "Preis- und Credit-Änderungen gelten für neue Buchungen. Bestehende Kunden behalten ihren gespeicherten Tarif-Snapshot, bis sie bewusst umgestellt werden.",
  "Invoice sender data": "Rechnungssteller",
  "Invoice sender data incomplete": "Rechnungssteller unvollständig",
  "Invoices cannot be created until sender name, address, country, email and tax data are complete.": "Rechnungen können erst erstellt werden, wenn Name, Adresse, Land, E-Mail und Steuernummer oder USt-IdNr. des Rechnungsstellers vollständig sind.",
  "Company name": "Firmenname",
  "Contact name": "Kontaktname",
  "Address line 1": "Straße und Hausnummer",
  "Address line 2": "Adresszusatz",
  "Postal code": "Postleitzahl",
  "City": "Ort",
  "Country": "Land",
  "Email": "E-Mail",
  "VAT ID": "USt-IdNr.",
  "Tax number": "Steuernummer",
  "Invoice data": "Rechnungsdaten",
  "Continue to payment": "Weiter zur Zahlung",
  "Invoice data required": "Rechnungsdaten erforderlich",
  "A purchase is only possible after the required invoice data has been entered.": "Ein Kauf ist erst möglich, nachdem die erforderlichen Rechnungsdaten eingegeben wurden.",
  "Billing policy saved": "Tarife gespeichert.",
  "Failed to load billing policy": "Tarife konnten nicht geladen werden.",
  "Failed to save billing policy": "Tarife konnten nicht gespeichert werden.",
  "Payment integration saved": "Zahlungsintegration gespeichert.",
  "Payment provider activation unavailable": "Für die Aktivierung müssen Zugangsdaten und Webhook hinterlegt sein.",
  "net": "netto",
  "Net amount": "Nettobetrag",
  "Tax": "Steuer",
  "Tax ({rate}%)": "Steuer ({rate} %)",
  "Tax treatment": "Steuerliche Behandlung",
  "invoice.note.reverseCharge": "Steuerschuldnerschaft des Leistungsempfängers (Reverse Charge)",
  "invoice.note.thirdCountry": "Steuerfreie Leistung an Empfänger außerhalb der EU",
  "Gross amount": "Bruttobetrag",
  "BillingAdminTabs.Plans": "Tarife",
  "BillingAdminTabs.PaymentIntegration": "Zahlungsintegration",
  "BillingAdminTabs.Invoices": "Rechnungen",
  "BillingAdminTabs.InvoiceSender": "Rechnungssteller",
  "BillingAdminTabs.InvoiceDesign": "Rechnungsdesign",
} as const;

export const sharedBillingEn = {
  "All payment methods": "All",
  "Selected payment methods": "Selected payment methods",
  "All future payment methods": "Future payment methods available from the provider are also allowed.",
  "Payment provider verification pending": "Payment methods are being checked in the background.",
  "Payment method unavailable at provider": "Unavailable at the provider. The saved selection is retained.",
  "Failed to load payment providers": "The payment providers could not be loaded. Please reload.",
  "PaymentProviderSettingsInvalid": "The payment settings are invalid. Please check the entries.",
  "PaymentProviderCredentialsRequired": "Credentials or webhook details are missing for activation.",
  "PaymentProviderMethodsUnavailable": "A payment method is unavailable at the provider. Please reload.",
  "PaymentProviderAccessDenied": "You do not have permission to manage these settings.",
  "PaymentProviderConflict": "The settings changed in the meantime. Please reload.",
  "Failed to save payment integration": "The payment integration could not be saved. Please try again.",
  "Reload payment providers": "reload",
  "Payment provider save mismatch": "The change was not saved completely. Please save again.",
  "Show payment credential": "Show credential",
  "Hide payment credential": "Hide credential",
  "Payment provider webhook rejected": "The webhook could not be verified. Check the webhook ID and its PayPal app.",
  "Failed to start checkout": "The payment could not be started.",
  "BillingPaymentProviderNotConfigured": "No payment provider is configured for this payment.",
  "Pay with PayPal": "Pay with PayPal",
  "Pay with Stripe": "Pay with Stripe",
  "Payment provider credentials rejected": "The payment provider rejected the credentials. Please check them.",
  "Payment provider verification failed": "The payment provider could not be verified. Please try again.",
  "Payment provider technical failure": "Verification stopped because of a technical failure. The operator must resolve the cause.",
  "Webhook endpoint unavailable": "No webhook endpoint is available for this provider.",
  "Copy webhook address": "Copy webhook address",
  "Webhook address copied": "Webhook address copied",
  ...sharedBillingWorkspaceEn,
  ...sharedBillingPageEn,
  ...sharedInvoiceDesignEn,
  "Stripe integration": "Stripe integration",
  "StripeAdminDescription": "Global Stripe configuration for payments. Secret keys are not managed in plain text in the UI.",
  "Inactive": "inactive",
  "Secret status": "Secret status",
  "configured": "configured",
  "missing": "missing",
  "webhook configured": "webhook configured",
  "webhook missing": "webhook missing",
  "Stripe publishable key": "Stripe publishable key",
  "Stripe webhook endpoint": "Stripe webhook endpoint",
  "Billing plans": "Billing plans",
  "Billing promotions": "Promotions",
  "Add billing plan": "Add billing plan",
  "Add billing plan version": "Add price variant",
  "Add billing promotion": "Add promotion",
  "Archive plan": "Archive plan",
  "Plan ID": "Plan ID",
  "Plan name": "Plan name",
  "Public plan": "Public plan",
  "Active version": "Active variant",
  "Version ID": "Variant ID",
  "Version name": "Variant name",
  "Monthly fee": "Monthly net price",
  "Yearly fee": "Yearly net price",
  "Annual payment discount": "Annual payment discount",
  "Currency": "Currency",
  "Published": "Published",
  "Trial enabled": "Trial enabled",
  "Trial days": "Trial days",
  "Plan limits": "Plan limits",
  "Set all limits to unlimited": "Set all limits to unlimited",
  "Promotion name": "Promotion name",
  "Public promotion": "Public promotion",
  "New customers only": "New customers only",
  "Assigned plans": "Assigned plans",
  "Monthly fee override": "Monthly net price override",
  "Yearly fee override": "Yearly net price override",
  "Starts at": "Starts at",
  "Ends at": "Ends at",
  "No billing plans configured": "No billing plans configured",
  "No billing promotions configured": "No promotions configured",
  "BillingPriceChangeNotice": "Price and credit changes apply to new subscriptions. Existing customers keep their stored plan snapshot until they are changed deliberately.",
  "Invoice sender data": "Invoice sender data",
  "Invoice sender data incomplete": "Invoice sender data incomplete",
  "Invoices cannot be created until sender name, address, country, email and tax data are complete.": "Invoices cannot be created until sender name, address, country, email and either tax number or VAT ID are complete.",
  "Company name": "Company name",
  "Contact name": "Contact name",
  "Address line 1": "Address line 1",
  "Address line 2": "Address line 2",
  "Postal code": "Postal code",
  "City": "City",
  "Country": "Country",
  "Email": "Email",
  "VAT ID": "VAT ID",
  "Tax number": "Tax number",
  "Invoice data": "Invoice data",
  "Continue to payment": "Continue to payment",
  "Invoice data required": "Invoice data required",
  "A purchase is only possible after the required invoice data has been entered.": "A purchase is only possible after the required invoice data has been entered.",
  "Billing policy saved": "Plans saved.",
  "Failed to load billing policy": "Failed to load plans.",
  "Failed to save billing policy": "Failed to save plans.",
  "Payment integration saved": "Payment integration saved.",
  "Payment provider activation unavailable": "Credentials and a webhook must be configured before activation.",
  "net": "net",
  "Net amount": "Net amount",
  "Tax": "Tax",
  "Tax ({rate}%)": "Tax ({rate}%)",
  "Tax treatment": "Tax treatment",
  "invoice.note.reverseCharge": "Reverse charge",
  "invoice.note.thirdCountry": "Tax-exempt supply to a recipient outside the EU",
  "Gross amount": "Gross amount",
  "BillingAdminTabs.Plans": "Plans",
  "BillingAdminTabs.PaymentIntegration": "Payment integration",
  "BillingAdminTabs.Invoices": "Invoices",
  "BillingAdminTabs.InvoiceSender": "Invoice sender",
  "BillingAdminTabs.InvoiceDesign": "Invoice design",
} as const;

export const sharedBillingRu = {
  "All payment methods": "Все",
  "Selected payment methods": "Выбранные способы оплаты",
  "All future payment methods": "Будущие доступные способы оплаты поставщика также разрешены.",
  "Payment provider verification pending": "Способы оплаты проверяются в фоновом режиме.",
  "Payment method unavailable at provider": "Недоступно у провайдера. Сохранённый выбор сохраняется.",
  "Failed to load payment providers": "Не удалось загрузить платёжных провайдеров. Загрузите данные снова.",
  "PaymentProviderSettingsInvalid": "Настройки оплаты недействительны. Проверьте введённые данные.",
  "PaymentProviderCredentialsRequired": "Для активации не хватает учётных данных или данных вебхука.",
  "PaymentProviderMethodsUnavailable": "Способ оплаты недоступен у провайдера. Загрузите данные снова.",
  "PaymentProviderAccessDenied": "У вас нет прав на управление этими настройками.",
  "PaymentProviderConflict": "Настройки уже изменены. Загрузите данные снова.",
  "Failed to save payment integration": "Не удалось сохранить платёжную интеграцию. Повторите попытку.",
  "Reload payment providers": "загрузить снова",
  "Payment provider save mismatch": "Изменение сохранено не полностью. Сохраните ещё раз.",
  "Show payment credential": "Показать учётные данные",
  "Hide payment credential": "Скрыть учётные данные",
  "Payment provider webhook rejected": "Не удалось подтвердить вебхук. Проверьте его ID и приложение PayPal.",
  "Failed to start checkout": "Не удалось начать оплату.",
  "BillingPaymentProviderNotConfigured": "Для этой оплаты не настроен платёжный провайдер.",
  "Pay with PayPal": "Оплатить через PayPal",
  "Pay with Stripe": "Оплатить через Stripe",
  "Payment provider credentials rejected": "Платёжный провайдер отклонил учётные данные. Проверьте их.",
  "Payment provider verification failed": "Не удалось проверить платёжного провайдера. Попробуйте ещё раз.",
  "Payment provider technical failure": "Проверка остановлена из-за технической ошибки. Оператор должен устранить причину.",
  "Webhook endpoint unavailable": "Для этого провайдера нет доступного адреса вебхука.",
  "Copy webhook address": "Копировать адрес вебхука",
  "Webhook address copied": "Адрес вебхука скопирован",
  ...sharedBillingWorkspaceRu,
  ...sharedBillingPageRu,
  ...sharedInvoiceDesignRu,
  "Stripe integration": "Интеграция Stripe",
  "StripeAdminDescription": "Глобальная конфигурация Stripe для платежей. Секретные ключи не отображаются и не редактируются в открытом виде в интерфейсе.",
  "Inactive": "неактивно",
  "Secret status": "Статус секретного ключа",
  "configured": "настроено",
  "missing": "отсутствует",
  "webhook configured": "вебхук настроен",
  "webhook missing": "вебхук отсутствует",
  "Stripe publishable key": "Публикуемый ключ Stripe",
  "Stripe webhook endpoint": "Конечная точка вебхука Stripe",
  "Billing plans": "Тарифы",
  "Billing promotions": "Акции",
  "Add billing plan": "добавить тариф",
  "Add billing plan version": "добавить ценовой вариант",
  "Add billing promotion": "добавить акцию",
  "Archive plan": "архивировать тариф",
  "Plan ID": "ID тарифа",
  "Plan name": "Название тарифа",
  "Public plan": "публичный тариф",
  "Active version": "активный вариант",
  "Version ID": "ID варианта",
  "Version name": "Название варианта",
  "Monthly fee": "ежемесячная цена нетто",
  "Yearly fee": "годовая цена нетто",
  "Annual payment discount": "Скидка при годовой оплате",
  "Currency": "Валюта",
  "Published": "опубликовано",
  "Trial enabled": "пробный период включён",
  "Trial days": "дни пробного периода",
  "Plan limits": "Лимиты тарифа",
  "Set all limits to unlimited": "установить все лимиты как безлимитные",
  "Promotion name": "Название акции",
  "Public promotion": "публичная акция",
  "New customers only": "только для новых клиентов",
  "Assigned plans": "назначенные тарифы",
  "Monthly fee override": "особая ежемесячная цена нетто",
  "Yearly fee override": "особая годовая цена нетто",
  "Starts at": "Начало",
  "Ends at": "Окончание",
  "No billing plans configured": "Тарифы не настроены",
  "No billing promotions configured": "Акции не настроены",
  "BillingPriceChangeNotice": "Изменения цен и кредитов действуют только для новых подписок. Существующие клиенты сохраняют зафиксированный снимок тарифа, пока их не переведут на новый тариф намеренно.",
  "Invoice sender data": "Данные отправителя счета",
  "Invoice sender data incomplete": "Данные отправителя счета неполные",
  "Invoices cannot be created until sender name, address, country, email and tax data are complete.": "Счета нельзя создать, пока имя, адрес, страна, e-mail и налоговый номер или номер НДС отправителя не заполнены полностью.",
  "Company name": "Название компании",
  "Contact name": "Контактное лицо",
  "Address line 1": "Улица и номер дома",
  "Address line 2": "Дополнение к адресу",
  "Postal code": "Почтовый индекс",
  "City": "Город",
  "Country": "Страна",
  "Email": "E-mail",
  "VAT ID": "Номер плательщика НДС",
  "Tax number": "Налоговый номер",
  "Invoice data": "Данные для счета",
  "Continue to payment": "Перейти к оплате",
  "Invoice data required": "Требуются данные для счета",
  "A purchase is only possible after the required invoice data has been entered.": "Покупка возможна только после ввода обязательных данных для счета.",
  "Billing policy saved": "Тарифы сохранены.",
  "Failed to load billing policy": "Не удалось загрузить тарифы.",
  "Failed to save billing policy": "Не удалось сохранить тарифы.",
  "Payment integration saved": "Платёжная интеграция сохранена.",
  "Payment provider activation unavailable": "Перед активацией необходимо настроить учётные данные и вебхук.",
  "net": "нетто",
  "Net amount": "Сумма нетто",
  "Tax": "Налог",
  "Tax ({rate}%)": "Налог ({rate}%)",
  "Tax treatment": "Налоговый режим",
  "invoice.note.reverseCharge": "Обратное начисление НДС",
  "invoice.note.thirdCountry": "Не облагаемая налогом услуга получателю за пределами ЕС",
  "Gross amount": "Сумма брутто",
  "BillingAdminTabs.Plans": "Тарифы",
  "BillingAdminTabs.PaymentIntegration": "Платёжная интеграция",
  "BillingAdminTabs.Invoices": "Счета",
  "BillingAdminTabs.InvoiceSender": "Выставитель счетов",
  "BillingAdminTabs.InvoiceDesign": "Дизайн счетов",
} as const;

export const sharedBillingUk = {
  "All payment methods": "Усі",
  "Selected payment methods": "Вибрані способи оплати",
  "All future payment methods": "Майбутні доступні способи оплати постачальника також дозволені.",
  "Payment provider verification pending": "Способи оплати перевіряються у фоновому режимі.",
  "Payment method unavailable at provider": "Недоступно у провайдера. Збережений вибір залишається.",
  "Failed to load payment providers": "Не вдалося завантажити платіжних провайдерів. Завантажте дані знову.",
  "PaymentProviderSettingsInvalid": "Налаштування оплати недійсні. Перевірте введені дані.",
  "PaymentProviderCredentialsRequired": "Для активації бракує облікових даних або даних вебхука.",
  "PaymentProviderMethodsUnavailable": "Спосіб оплати недоступний у провайдера. Завантажте дані знову.",
  "PaymentProviderAccessDenied": "У вас немає прав на керування цими налаштуваннями.",
  "PaymentProviderConflict": "Налаштування вже змінено. Завантажте дані знову.",
  "Failed to save payment integration": "Не вдалося зберегти платіжну інтеграцію. Спробуйте ще раз.",
  "Reload payment providers": "завантажити знову",
  "Payment provider save mismatch": "Зміну збережено не повністю. Збережіть ще раз.",
  "Show payment credential": "Показати облікові дані",
  "Hide payment credential": "Приховати облікові дані",
  "Payment provider webhook rejected": "Не вдалося підтвердити вебхук. Перевірте його ID та застосунок PayPal.",
  "Failed to start checkout": "Не вдалося розпочати оплату.",
  "BillingPaymentProviderNotConfigured": "Для цієї оплати не налаштовано платіжного провайдера.",
  "Pay with PayPal": "Сплатити через PayPal",
  "Pay with Stripe": "Сплатити через Stripe",
  "Payment provider credentials rejected": "Платіжний провайдер відхилив облікові дані. Перевірте їх.",
  "Payment provider verification failed": "Не вдалося перевірити платіжного провайдера. Спробуйте ще раз.",
  "Payment provider technical failure": "Перевірку зупинено через технічну помилку. Оператор має усунути причину.",
  "Webhook endpoint unavailable": "Для цього провайдера немає доступної адреси вебхука.",
  "Copy webhook address": "Копіювати адресу вебхука",
  "Webhook address copied": "Адресу вебхука скопійовано",
  ...sharedBillingWorkspaceUk, ...sharedBillingPageUk, ...sharedInvoiceDesignUk,
  "BillingAdminTabs.Plans": "Тарифи", "BillingAdminTabs.PaymentIntegration": "Платіжна інтеграція", "BillingAdminTabs.Invoices": "Рахунки", "BillingAdminTabs.InvoiceSender": "Виставник рахунків", "BillingAdminTabs.InvoiceDesign": "Дизайн рахунків",
  "Monthly fee": "Щомісячна ціна нетто", "Yearly fee": "Річна ціна нетто", "Monthly fee override": "Інша щомісячна ціна нетто", "Yearly fee override": "Інша річна ціна нетто",
  "Payment provider activation unavailable": "Перед активацією потрібно налаштувати облікові дані та вебхук.",
  "net": "нетто", "Net amount": "Сума нетто", "Tax": "Податок", "Tax ({rate}%)": "Податок ({rate}%)", "Tax treatment": "Податковий режим", "invoice.note.reverseCharge": "Зворотне нарахування ПДВ", "invoice.note.thirdCountry": "Неоподатковувана послуга отримувачу за межами ЄС", "Gross amount": "Сума брутто",
};
export const sharedBillingIt = {
  "All payment methods": "Tutti",
  "Selected payment methods": "Metodi di pagamento selezionati",
  "All future payment methods": "Sono consentiti anche i futuri metodi di pagamento disponibili dal fornitore.",
  "Payment provider verification pending": "I metodi di pagamento vengono verificati in background.",
  "Payment method unavailable at provider": "Non disponibile presso il fornitore. La selezione salvata viene mantenuta.",
  "Failed to load payment providers": "Impossibile caricare i fornitori di pagamento. Ricarica i dati.",
  "PaymentProviderSettingsInvalid": "Le impostazioni di pagamento non sono valide. Controlla i dati inseriti.",
  "PaymentProviderCredentialsRequired": "Per l’attivazione mancano credenziali o dati del webhook.",
  "PaymentProviderMethodsUnavailable": "Un metodo di pagamento non è disponibile presso il fornitore. Ricarica i dati.",
  "PaymentProviderAccessDenied": "Non hai il permesso di gestire queste impostazioni.",
  "PaymentProviderConflict": "Le impostazioni sono state modificate nel frattempo. Ricarica i dati.",
  "Failed to save payment integration": "Impossibile salvare l’integrazione di pagamento. Riprova.",
  "Reload payment providers": "ricarica",
  "Payment provider save mismatch": "La modifica non è stata salvata completamente. Salva di nuovo.",
  "Show payment credential": "Mostra credenziali",
  "Hide payment credential": "Nascondi credenziali",
  "Payment provider webhook rejected": "Impossibile verificare il webhook. Controllare l'ID e l'app PayPal.",
  "Failed to start checkout": "Impossibile avviare il pagamento.",
  "BillingPaymentProviderNotConfigured": "Nessun provider configurato per questo pagamento.",
  "Pay with PayPal": "Paga con PayPal",
  "Pay with Stripe": "Paga con Stripe",
  "Payment provider credentials rejected": "Il provider ha rifiutato le credenziali. Verificarle.",
  "Payment provider verification failed": "Impossibile verificare il provider di pagamento. Riprovare.",
  "Payment provider technical failure": "Verifica interrotta per un errore tecnico. Il gestore deve risolverne la causa.",
  "Webhook endpoint unavailable": "Nessun endpoint webhook disponibile per questo provider.",
  "Copy webhook address": "Copia indirizzo webhook",
  "Webhook address copied": "Indirizzo webhook copiato",
  ...sharedBillingWorkspaceIt, ...sharedBillingPageIt, ...sharedInvoiceDesignIt,
  "BillingAdminTabs.Plans": "Piani", "BillingAdminTabs.PaymentIntegration": "Integrazione pagamenti", "BillingAdminTabs.Invoices": "Fatture", "BillingAdminTabs.InvoiceSender": "Emittente della fattura", "BillingAdminTabs.InvoiceDesign": "Design della fattura",
  "Monthly fee": "Prezzo mensile netto", "Yearly fee": "Prezzo annuale netto", "Monthly fee override": "Prezzo mensile netto alternativo", "Yearly fee override": "Prezzo annuale netto alternativo",
  "Payment provider activation unavailable": "Prima dell'attivazione occorre configurare le credenziali e il webhook.",
  "net": "netto", "Net amount": "Importo netto", "Tax": "Imposta", "Tax ({rate}%)": "Imposta ({rate}%)", "Tax treatment": "Trattamento fiscale", "invoice.note.reverseCharge": "Inversione contabile", "invoice.note.thirdCountry": "Prestazione esente a un destinatario fuori dall'UE", "Gross amount": "Importo lordo",
};
